<div class="p-4 flex justify-between">
  <span class="font-semibold text-xl">{{'help.help-header' | translate}}</span>
  <app-close-button class="self-center mt-1" (close)="onClose()"></app-close-button>
</div>

<div class=" h-full flex flex-col place-items-center tk-bg-gray-5">

  <div class="mt-40  tk-i-help-big ml-auto mr-auto"></div>
  <div class="mt-4 font-semibold text-sm">{{'help.issue-question' | translate}}</div>

  <div class="mt-3 text-xs tk-c-gray">
    <div class="text-center">{{'help.goto-info-part1' | translate}}</div>
    <div>{{'help.goto-info-part2' | translate}}</div>
  </div>

  <button class="mt-4 tk-bg-blue tk-bg-blue-dark-hover text-white rounded-md py-2 hover:font-normal w-36"
          (click)="onKnowledgeDatabase()">
    {{'help.knowledge-db' | translate}}
  </button>

  <div class="mt-16 font-semibold text-sm">{{'help.need-help' | translate}}</div>

  <div class="mt-4 mx-4 py-4 px-11 bg-white rounded-md text-xs flex flex-col items-center">
    <div class="tk-c-gray">{{'help.write-or-call' | translate}}</div>
    <div>
      <a class="link mr-1" href="mailto:{{'contact.email' | translate}}">{{'contact.email' | translate}}</a>,
      <a href="tel:{{'contact.phone-no-spaces' | translate}}"><span class="text-black">
          {{'contact.phone' | translate}}
        </span></a>
    </div>
  </div>
</div>
